/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-03-13 10:48:19
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-06 14:08:13
 */
import React, { useState } from 'react';

import SFCVditor from './SFCVditor';
import 'vditor/dist/index.css';
import './Markdown.less';
import SFCReadVditor from './SFCReadVditor';

export interface IMarkdownProps {
  className?: string;
  content?: string;
  changeVal?: (val: string) => void;
  /** 是否处于编辑状态 */
  edit?: boolean;
}
type Props = IMarkdownProps;

export function Markdown(props: Readonly<Props>) {
  const { className = '', content = '', changeVal, edit = true } = props;
  const changeValue = (value: string) => {
    changeVal && changeVal(value);
  };

  return (
    <div className="common-presenter k-common-markdown">
      {edit ? (
        <SFCVditor className={className} content={content} changeVal={changeValue} />
      ) : (
        <SFCReadVditor content={content} />
      )}
    </div>
  );
}

export default Markdown;
